import { render, staticRenderFns } from "./DatagramsList.vue?vue&type=template&id=3b1aa10a&scoped=true"
import script from "./DatagramsList.vue?vue&type=script&lang=js"
export * from "./DatagramsList.vue?vue&type=script&lang=js"
import style0 from "./DatagramsList.vue?vue&type=style&index=0&id=3b1aa10a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1aa10a",
  null
  
)

export default component.exports